import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Review from "../../components/Review/Review";
import ReviewInput from "../../components/ReviewInput/ReviewInput";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import Map from "../../components/Map/Map";
import "./ReviewPage.scss";
import { Link } from "react-router-dom";
export default function ReviewPage(props) {
  const [currentLocation, setLocation] = useState({});
  const [reviewInfo, setReviewInfo] = useState({});
  const { REACT_APP_API_ENDPOINT } = process.env;
  function fetchData() {
    axios
      .get(REACT_APP_API_ENDPOINT + "/" + props.match.params.id)
      .then((res) => {
        console.log(res);
        setReviewInfo(res.data);
        setLocation({
          lat: Number(res.data.lat),
          lng: Number(res.data.lng),
        });
      })
      .catch((err) => console.log(err));
  }
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="review-page">
      <Map currentLocation={currentLocation} setLocation={setLocation} />
      <div className="review-page__wrap">
        <div className="review-page__back-button">
          <Link to="/">
            <div className="review-page__back"></div>
            <p className="review-page__text">Back to Home</p>
          </Link>
        </div>
        <div className="review-page__wrap-top">
          <h3 className="review-page__page-title">
            Review your rental experience:
          </h3>
          <h3 className="review-page__title">
            {reviewInfo ? reviewInfo.name : <LoadingSpinner />}
          </h3>

          <p className="review-page__text">
            {reviewInfo ? reviewInfo.address : <LoadingSpinner />}
            {reviewInfo ? reviewInfo.city : <LoadingSpinner />}
          </p>
          <ReviewInput
            data={reviewInfo ? reviewInfo : <LoadingSpinner />}
            fetchData={fetchData ? fetchData : <LoadingSpinner />}
          />
        </div>
        <div className="review-page__review-wrap">
          {reviewInfo.reviews ? (
            reviewInfo.reviews
              .sort((a, b) => b.timestamp - a.timestamp)
              .map((review) => (
                <Review
                  data={review ? review : <LoadingSpinner />}
                  key={uuidv4()}
                />
              ))
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </div>
  );
}
